module.exports = __webpack_public_path__ + "/static/assets/Icon-Lang-Earth.9a9d7e96.9a9d7e96.png";